<template>
  <div class="p-fluid p-formgrid p-grid">
    
    <div class="p-field p-col-12 p-md-12">
      <div class="p-field-checkbox">
          <Checkbox id="binary" v-model="incluirBancoHoras" :binary="true" />
          <label for="binary">Incluir banco de horas</label>
      </div>
      <TabView v-if="incluirBancoHoras">
          <TabPanel header="Armazenamento" class="p-mt-3">
            <div class="p-field p-col-12 p-md-12">
              <h6 class="p-text-bold">Abrangências para débitos</h6>
              <div class="p-field-checkbox">
                  <Checkbox v-model="bhArmazenamento.faltas" :binary="true"/>
                <label>Faltas</label>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox v-model="bhArmazenamento.atrasos" :binary="true"/>
                <label>Atrasos</label>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox v-model="bhArmazenamento.saidasAntecipadas" :binary="true"/>
                <label>Saídas antecipadas</label>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox v-model="bhArmazenamento.excessoIntevaloRefeicoes" :binary="true"/>
                <label>Excessos nos int. das refeições</label>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox v-model="bhArmazenamento.faltaDeMarcacao" :binary="true"/>
                <label>Falta de marcação</label>
              </div>
            </div> 

            <div class="p-field p-col-12 p-md-12 p-mt-5">
              <h6 class="p-text-bold">Abrangências para créditos <span class="campo-obrigatorio">*</span></h6>
              <div class="p-fluid p-formgrid p-grid">   
                <div class="p-field-checkbox p-ml-2">
                  <Checkbox v-model="bhArmazenamento.horaExtraSegunda" :binary="true"/>
                </div>     
                <div class="p-field p-col-2 p-md-2">
                  <label>Segunda-Feira</label>
                  <InputText v-model="bhArmazenamento.limiteHESegunda" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('limiteHESegunda')"/>
                </div>
              </div>
              <div class="p-fluid p-formgrid p-grid">   
                <div class="p-field-checkbox p-ml-2">
                  <Checkbox v-model="bhArmazenamento.horaExtraTerca" :binary="true"/>
                </div>     
                <div class="p-field p-col-2 p-md-2">
                  <label>Terça-Feira</label>
                  <InputText v-model="bhArmazenamento.limiteHETerca" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('limiteHETerca')"/>
                </div>
              </div>
              <div class="p-fluid p-formgrid p-grid">   
                <div class="p-field-checkbox p-ml-2">
                  <Checkbox v-model="bhArmazenamento.horaExtraQuarta" :binary="true"/>
                </div>     
                <div class="p-field p-col-2 p-md-2">
                  <label>Quarta-Feira</label>
                  <InputText v-model="bhArmazenamento.limiteHEQuarta" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('limiteHEQuarta')"/>
                </div>
              </div>
              <div class="p-fluid p-formgrid p-grid">   
                <div class="p-field-checkbox p-ml-2">
                  <Checkbox v-model="bhArmazenamento.horaExtraQuinta" :binary="true"/>
                </div>     
                <div class="p-field p-col-2 p-md-2">
                  <label>Quinta-Feira</label>
                  <InputText v-model="bhArmazenamento.limiteHEQuinta" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('limiteHEQuinta')"/>
                </div>
              </div>
              <div class="p-fluid p-formgrid p-grid">   
                <div class="p-field-checkbox p-ml-2">
                  <Checkbox v-model="bhArmazenamento.horaExtraSexta" :binary="true"/>
                </div>     
                <div class="p-field p-col-2 p-md-2">
                  <label>Sexta-Feira</label>
                  <InputText v-model="bhArmazenamento.limiteHESexta" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('limiteHESexta')"/>
                </div>
              </div>
              <div class="p-fluid p-formgrid p-grid">   
                <div class="p-field-checkbox p-ml-2">
                  <Checkbox v-model="bhArmazenamento.horaExtraSabados" :binary="true"/>
                </div>     
                <div class="p-field p-col-2 p-md-2">
                  <label>Sábados</label>
                  <InputText v-model="bhArmazenamento.limiteHESabados" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('limiteHESabados')"/>
                </div>
              </div>
              <div class="p-fluid p-formgrid p-grid">   
                <div class="p-field-checkbox p-ml-2">
                  <Checkbox v-model="bhArmazenamento.horaExtraDomingos" :binary="true"/>
                </div>     
                <div class="p-field p-col-2 p-md-2">
                  <label>Domingos</label>
                  <InputText v-model="bhArmazenamento.limiteHEDomingos" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('limiteHEDomingos')"/>
                </div>
              </div>
              <div class="p-fluid p-formgrid p-grid">   
                <div class="p-field-checkbox p-ml-2">
                  <Checkbox v-model="bhArmazenamento.horaExtraFeriados" :binary="true"/>
                </div>     
                <div class="p-field p-col-2 p-md-2">
                  <label>Feriados</label>
                  <InputText v-model="bhArmazenamento.limiteHEFeriados" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('limiteHEFeriados')"/>
                </div>
              </div> 
              <div class="p-fluid p-formgrid p-grid">   
                <div class="p-field-checkbox p-ml-2">
                  <Checkbox v-model="bhArmazenamento.horaExtraFolgas" :binary="true"/>
                </div>     
                <div class="p-field p-col-2 p-md-2">
                  <label>Folgas</label>
                  <InputText v-model="bhArmazenamento.limiteHEFolgas" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('limiteHEFolgas')"/>
                </div>
              </div>            
            </div>                      
          </TabPanel>
          <TabPanel header="Transferência" class="p-mt-3">
            <h6 class="p-text-bold">Transferência de horas extras</h6>
            <h6 class="p-text-bold">Faixas <span class="campo-obrigatorio">*</span></h6>
            <div class="p-fluid p-formgrid p-grid">                
              <div class="p-field p-col-2 p-md-1">
                <label>Seg</label>
                <InputText v-model.number="bhTransferencia.faixaSegunda" type="number" class="p-text-center" placeholder="%" min="0"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Ter</label>
                <InputText v-model.number="bhTransferencia.faixaTerca" type="number" class="p-text-center" placeholder="%" min="0"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Qua</label>
                <InputText v-model.number="bhTransferencia.faixaQuarta" type="number" class="p-text-center" placeholder="%" min="0"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Qui</label>
                <InputText v-model.number="bhTransferencia.faixaQuinta" type="number" class="p-text-center" placeholder="%" min="0"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Sex</label>
                <InputText v-model.number="bhTransferencia.faixaSexta" type="number" class="p-text-center" placeholder="%" min="0"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Sábados</label>
                <InputText v-model.number="bhTransferencia.faixaSabados" type="number" class="p-text-center" placeholder="%" min="0"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Domingos</label>
                <InputText v-model.number="bhTransferencia.faixaDomingos" type="number" class="p-text-center" placeholder="%" min="0"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Feriados</label>
                <InputText v-model.number="bhTransferencia.faixaFeriados" type="number" class="p-text-center" placeholder="%" min="0"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Folgas</label>
                <InputText v-model.number="bhTransferencia.faixaFolgas" type="number" class="p-text-center" placeholder="%" min="0"/>
              </div>          
            </div>
            <h6 class="p-text-bold">Fator <span class="campo-obrigatorio">*</span></h6>
            <div class="p-fluid p-formgrid p-grid">                
              <div class="p-field p-col-2 p-md-1">
                <label>Seg</label>
                <InputText v-model="bhTransferencia.fatorSegunda" class="p-text-center" @keyup="formatarEtrada"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Ter</label>
                <InputText v-model="bhTransferencia.fatorTerca" class="p-text-center" @keyup="formatarEtrada"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Qua</label>
                <InputText v-model="bhTransferencia.fatorQuarta" class="p-text-center" @keyup="formatarEtrada"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Qui</label>
                <InputText v-model="bhTransferencia.fatorQuinta" class="p-text-center" @keyup="formatarEtrada"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Sex</label>
                <InputText v-model="bhTransferencia.fatorSexta" class="p-text-center" @keyup="formatarEtrada"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Sábados</label>
                <InputText v-model="bhTransferencia.fatorSabados" class="p-text-center" @keyup="formatarEtrada"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Domingos</label>
                <InputText v-model="bhTransferencia.fatorDomingos" class="p-text-center" @keyup="formatarEtrada"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Feriados</label>
                <InputText v-model="bhTransferencia.fatorFeriados" class="p-text-center" @keyup="formatarEtrada"/>
              </div>
              <div class="p-field p-col-2 p-md-1">
                <label>Folgas</label>
                <InputText v-model="bhTransferencia.fatorFolgas" class="p-text-center" @keyup="formatarEtrada"/>
              </div>          
            </div>
          </TabPanel>
      </TabView>
    </div>

    <div class="p-field p-col-12 p-md-12 p-ml-3" v-if="incluirBancoHoras">
      <h6 class="p-text-bold">Prioridade das horas extras</h6>
      <div class="p-field-radiobutton">
        <RadioButton id="prioridadeHoraExtra1" name="prioridadeHoraExtra" v-model.number="prioridadeHoraExtra" :value="1"/>
        <label>Primeiro calcular para banco de horas</label>
      </div>
      <div class="p-field-radiobutton">
        <RadioButton id="prioridadeHoraExtra2" name="prioridadeHoraExtra" v-model.number="prioridadeHoraExtra" :value="2"/>
        <label>Primeiro calcular para horas extras</label>
      </div>    
    </div> 

    <div class="p-field p-col-12 p-md-12 p-ml-3" v-if="incluirBancoHoras">
      <h6 class="p-text-bold">Período <span class="campo-obrigatorio">*</span></h6>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-2 p-md-2">
          <label>Início</label>
          <Calendar v-model="politicaBancoHora.periodoInicial" view="month" dateFormat="mm/yy" :showIcon="true"
           :manualInput="false" :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR"/>
        </div>
        <div class="p-field p-col-2 p-md-2">
          <label>Final</label>
          <Calendar v-model="politicaBancoHora.periodoFinal" view="month" dateFormat="mm/yy" :showIcon="true" 
          :manualInput="false" :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR"/>
        </div>
      </div>      
    </div>         

  </div>
</template>

<script>
import PoliticaBancoHora from '@/model/PoliticaBancoHora';
import BancoHoraArmazenamento from '@/model/BancoHoraArmazenamento';
import BancoHoraTransferencia from '@/model/BancoHoraTransferencia';
import { formatarEtradaHora, formatarEtradaFloat, localeCalendarBR } from '@/global';

export default {
  data() {
    return {
      prioridadeHoraExtra: 2,
      incluirBancoHoras: false,
      rangeData: '',
      politicaBancoHora: new PoliticaBancoHora(),
      bhArmazenamento: new BancoHoraArmazenamento(),
      bhTransferencia: new BancoHoraTransferencia(),
      localeCalendarBR: localeCalendarBR,
    }
  },
  methods: {
    setConfiguracao(politicaBancoHora, bancoHoraArmazenamento, bancoHoraTransferencia, prioridadeHoraExtra) {
      if(politicaBancoHora != null) {
        this.calcularPercentual(bancoHoraTransferencia, '*');
        this.politicaBancoHora = politicaBancoHora;
        this.bhArmazenamento = bancoHoraArmazenamento;
        this.bhTransferencia = bancoHoraTransferencia;
        this.prioridadeHoraExtra = prioridadeHoraExtra;
        this.incluirBancoHoras = true;
      }      
    },
    getConfiguracao() {
      let configuracao = null;
      if(this.incluirBancoHoras) {
        if(this.politicaBancoHora.periodoInicial == null || this.politicaBancoHora.periodoFinal == null) {
          throw 'Banco de horas: Selecione um período para início do banco de horas e todos os campos obrigatórios'
        }        
        configuracao = {
          incluirBancoHoras: this.incluirBancoHoras,
          prioridadeHoraExtra: this.prioridadeHoraExtra,
          bhArmazenamento: {...this.bhArmazenamento},
          bhTransferencia: {...this.bhTransferencia},
          politicaBancoHora: {...this.politicaBancoHora}
        };
        this.calcularPercentual(configuracao.bhTransferencia, '/');
      } else {
        configuracao = {incluirBancoHoras: this.incluirBancoHoras};
      }           
      return configuracao;      
    },
    limparEntradaHoraInvalida(campo) {
      if(this.bhArmazenamento[campo] == null) {
        return;
      }
      let regex = /[0-2][0-9]:[0-5][0-9]/g;
      if(!this.bhArmazenamento[campo].match(regex)) {
        this.bhArmazenamento[campo] = '';
      }
    },
    validarEntraHora(event) {
      formatarEtradaHora(event);
    },
    formatarEtrada(event) {
      formatarEtradaFloat(event);
    },
    criarRangeData() {
      let anoAtual = new Date().getFullYear();     
      this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
    },
    calcularPercentual(bhTransferencia, operador) {           
      if(!isNaN(bhTransferencia.faixaSegunda)) {
        if(operador == '/') {
          bhTransferencia.faixaSegunda = bhTransferencia.faixaSegunda / 100;
        } else {
          bhTransferencia.faixaSegunda = bhTransferencia.faixaSegunda * 100;
        }
      }
      if(!isNaN(bhTransferencia.faixaTerca)) {
        if(operador == '/') {
          bhTransferencia.faixaTerca = bhTransferencia.faixaTerca / 100;
        } else {
          bhTransferencia.faixaTerca = bhTransferencia.faixaTerca * 100;
        }
      }
      if(!isNaN(bhTransferencia.faixaQuarta)) {
        if(operador == '/') {
          bhTransferencia.faixaQuarta = bhTransferencia.faixaQuarta / 100;
        } else {
          bhTransferencia.faixaQuarta = bhTransferencia.faixaQuarta * 100;
        }
      }
      if(!isNaN(bhTransferencia.faixaQuinta)) {
        if(operador == '/') {
          bhTransferencia.faixaQuinta = bhTransferencia.faixaQuinta / 100;
        } else {
          bhTransferencia.faixaQuinta = bhTransferencia.faixaQuinta * 100;
        }
      }
      if(!isNaN(bhTransferencia.faixaSexta)) {
        if(operador == '/') {
          bhTransferencia.faixaSexta = bhTransferencia.faixaSexta / 100;
        } else {
          bhTransferencia.faixaSexta = bhTransferencia.faixaSexta * 100;
        }
      }
      if(!isNaN(bhTransferencia.faixaSabados)) {
        if(operador == '/') {
          bhTransferencia.faixaSabados = bhTransferencia.faixaSabados / 100;
        } else {
          bhTransferencia.faixaSabados = bhTransferencia.faixaSabados * 100;
        }          
      }
      if(!isNaN(bhTransferencia.faixaDomingos)) {        
        if(operador == '/') {
          bhTransferencia.faixaDomingos = bhTransferencia.faixaDomingos / 100;
        } else {
          bhTransferencia.faixaDomingos = bhTransferencia.faixaDomingos * 100;
        }
      }
      if(!isNaN(bhTransferencia.faixaFeriados)) {
        if(operador == '/') {
          bhTransferencia.faixaFeriados = bhTransferencia.faixaFeriados / 100;
        } else {
          bhTransferencia.faixaFeriados = bhTransferencia.faixaFeriados * 100;
        }        
      }
      if(!isNaN(bhTransferencia.faixaFolgas)) {
        if(operador == '/') {
          bhTransferencia.faixaFolgas = bhTransferencia.faixaFolgas / 100;
        } else {
          bhTransferencia.faixaFolgas = bhTransferencia.faixaFolgas * 100;
        }   
      }
    }
  },
  created() {
    this.criarRangeData();
  }
}
</script>

<style>

</style>